import { Button, Input, Radio, Select, Space, Typography } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { FieldMeta } from '../../../api/types';
import type { InfoGridSection, InfoGridItem } from '../../../contract/types';
import { genId } from '../../../contract/types';

interface Props {
  section: InfoGridSection;
  onChange: (s: InfoGridSection) => void;
  fieldMetas: FieldMeta[];
}

export function InfoGridEditor({ section, onChange, fieldMetas }: Props) {
  const fieldOptions = fieldMetas.map((m) => ({
    label: m.name,
    value: m.id,
  }));

  const updateItem = (id: string, patch: Partial<InfoGridItem>) => {
    const items = section.items.map((it) => (it.id === id ? { ...it, ...patch } : it));
    onChange({ ...section, items });
  };

  const addItem = () => {
    const item: InfoGridItem = { id: genId(), label: '', fieldId: null, staticValue: '' };
    onChange({ ...section, items: [...section.items, item] });
  };

  const removeItem = (id: string) => {
    onChange({ ...section, items: section.items.filter((it) => it.id !== id) });
  };

  return (
    <div>
      <div style={{ marginBottom: 8 }}>
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>每行列数</Typography.Text>
        <br />
        <Radio.Group
          size="small"
          value={section.columns}
          onChange={(e) => onChange({ ...section, columns: e.target.value })}
          optionType="button"
          options={[
            { label: '1列', value: 1 },
            { label: '2列', value: 2 },
            { label: '3列', value: 3 },
          ]}
        />
      </div>

      {section.items.map((item) => (
        <div
          key={item.id}
          style={{
            display: 'flex',
            gap: 4,
            alignItems: 'center',
            marginBottom: 4,
          }}
        >
          <Input
            size="small"
            style={{ width: 100 }}
            placeholder="标签"
            value={item.label}
            onChange={(e) => updateItem(item.id, { label: e.target.value })}
          />
          <Select
            size="small"
            style={{ flex: 1, minWidth: 0 }}
            placeholder="绑定字段"
            allowClear
            showSearch
            optionFilterProp="label"
            value={item.fieldId}
            onChange={(v) => updateItem(item.id, { fieldId: v ?? null, staticValue: '' })}
            options={fieldOptions}
          />
          {!item.fieldId && (
            <Input
              size="small"
              style={{ width: 80 }}
              placeholder="静态值"
              value={item.staticValue}
              onChange={(e) => updateItem(item.id, { staticValue: e.target.value })}
            />
          )}
          <Button
            size="small"
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => removeItem(item.id)}
          />
        </div>
      ))}

      <Space size={8}>
        <Button size="small" icon={<PlusOutlined />} onClick={addItem}>
          添加项
        </Button>
      </Space>
    </div>
  );
}
